import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import DropingPointModel from "../../models/party/dropingpoint-model";
import AreaModel from "../../models/party/area-model";

const url = getEndPoint(API_END_POINT.PARTY) +"/api/DroppingPoint/GetAllDropingPoint/1";// //{/api/DropingPoint/GetAlldropingPoint}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetDroppingPoint = createQuery<
  DropingPointModel[],
  null,
  AxiosError
>({
  queryKey: ["keyDroppingPointpage"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
const customerurl = getEndPoint(API_END_POINT.PARTY) +"/api/DroppingPoint/GetAllDropingPoint/2";// //{/api/DropingPoint/GetAlldropingPoint}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetDroppingPoints = createQuery<
  DropingPointModel[],
  null,
  AxiosError
>({
  queryKey: ["keyCustomerpage"],
  fetcher: (params) =>
        getDataWithToken<any>(customerurl).then((response) => response.data?.result || console.log(response)),
    
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
const areaUrl = getEndPoint(API_END_POINT.PARTY) +"/api/DroppingPoint/GetAllArea";// //{/api/Employee/GetAllemployee}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetArea = createQuery<
  AreaModel[],
  null,
  AxiosError
>({
  queryKey: ["keyAreapage"],
  fetcher: (params) =>
        getDataWithToken<any>(areaUrl).then((response) => response.data?.result || console.log(response)),
    
    // axios.get(areaUrl, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});